import React, { useEffect, useState } from 'react';
import { calculatedParamsMiddleware, fetchTargets, mergeMiddlewares } from '@cian/adfox';

import { TBannerPlace } from '../../types/adfoxBanner';
import { AdFoxBanner } from '../../components/AdFoxBanner';
import { IAdfoxConstants } from '../../components/adfox/constants';

interface IBannerProps {
  place: TBannerPlace;
  constants: IAdfoxConstants;
  height?: string;
  className?: string;
}

const adfoxMiddleware = (constants: IAdfoxConstants) => {
  return mergeMiddlewares(
    calculatedParamsMiddleware(),
    fetchTargets('apps', {
      baseUrl: `//${window.__mainpage_api_host__ || window.location.host}/`,
      section_type: 1,
    }),
    Promise.resolve(constants),
  );
};

export function Banner({ constants, place, height = '273px', className }: IBannerProps) {
  const [params, setParams] = useState<Record<string, string> | null>(null);

  useEffect(() => {
    adfoxMiddleware(constants).then(res => {
      setParams(res);
    });
  }, [constants]);

  if (!params) {
    return null;
  }

  return (
    <AdFoxBanner
      ownerId={202100}
      lazyLoad={true}
      params={params}
      place={place}
      width="100%"
      height={height}
      className={className}
    />
  );
}

Banner.displayName = 'Banner';
